import React from 'react';
import ReactDOM from 'react-dom/client';
// Typsnitt och Leaflet-stilar bundlas med appen i stället för att hämtas
// från Google Fonts respektive unpkg — inga externa anrop.
import '@fontsource-variable/sora';
import 'leaflet/dist/leaflet.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
